var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.loading
        ? _c("EmcBaseProgressBar")
        : _c("v-simple-table", {
            attrs: { dense: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Unidade")]),
                        _c("th", [_vm._v("Atividade")]),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v("Período"),
                        ]),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v("CH"),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_setup.items, function (item) {
                        return _c("tr", { key: item.id }, [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                item.activity_offered.branch
                                  ? item.activity_offered.branch.name
                                  : ""
                              )
                            ),
                          ]),
                          _c("td", [
                            _vm._v(_vm._s(item.activity_offered.name)),
                          ]),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(_setup.period(item))),
                          ]),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(Number(item.work_load || 0))),
                          ]),
                        ])
                      }),
                      0
                    ),
                    _setup.items.length > 0
                      ? _c("tfoot", [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-right",
                                attrs: { colspan: "3" },
                              },
                              [_c("strong", [_vm._v("Total:")])]
                            ),
                            _c("td", { staticClass: "text-center" }, [
                              _c("strong", [_vm._v(_vm._s(_setup.total))]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }